"use client"
import { Link } from "@heroui/react"
import { DateTime } from "luxon"
import { useTranslations } from "next-intl"

export function Footer() {
  const t = useTranslations("Footer")
  return (
    <footer className="bg-content1/50 backdrop-blur-md shadow-lg px-4 md:px-8 xl:px-12 py-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center space-y-4 md:space-y-0">
          <div className="space-y-2">
            <div className="font-bold text-lg bg-gradient-to-r from-primary-500 to-secondary-500 bg-clip-text text-transparent">
              Nexum Space VIP
            </div>
            <div className="text-sm text-default-500">
              © {DateTime.now().toFormat("yyyy")} Nexum Space VIP. {t("allRightsReserved")}
            </div>
            <div className="text-sm text-default-600">
              {t("contactUs")}: <Link
                className="text-primary hover:text-primary-600 transition-colors font-medium"
                href="mailto:info@nexumspace.com"
              >
                info@nexumspace.com
              </Link>
            </div>
          </div>
          <div className="flex gap-6">
            <Link
              className="text-sm text-default-600 hover:text-default-900 transition-colors font-medium"
              href="/terms"
            >
              {t("termsAndConditions")}
            </Link>
            <Link
              className="text-sm text-default-600 hover:text-default-900 transition-colors font-medium"
              href="/privacy"
            >
              {t("privacyPolicy")}
            </Link>
          </div>
        </div>
        <div className="mt-6 pt-4">
          <p className="text-xs text-default-400 text-center">
            {t('securityMessage')}
          </p>
        </div>
      </div>
    </footer>
  )
}